import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/shared/ui/hooks'
import { AppShellSkeleton } from '@/shared/ui/layout/app-shell-skeleton'

export function PrivateRoute() {
  const { user, isLoading, restoreTimedOut } = useAuth()
  const location = useLocation()

  if (isLoading) {
    if (restoreTimedOut) {
      return (
        <div
          data-testid="auth-restore-timeout"
          className="min-h-screen flex items-center justify-center bg-background"
        >
          <div className="flex flex-col items-center gap-3 text-center">
            <span className="text-sm text-muted-foreground">
              Taking longer than expected — retry?
            </span>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
            >
              Retry
            </button>
          </div>
        </div>
      )
    }
    return <AppShellSkeleton testId="auth-loading" />
  }

  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />
  }

  return <Outlet />
}
